import React, { useMemo } from "react";
import { format } from "date-fns";
import Table from "../../../components/ui/table/Table";

const BhavConfig = ({ tableData, loading }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "date",
        header: "DATE",
        sortingFn: "datetime",
        Cell: ({ row }) => format(new Date(row.original.date), "dd MMM yyyy"),
      },
      {
        accessorKey: "day",
        header: "WEEKDAY",
      },
      {
        accessorKey: "segment",
        header: "SEGMENT",
      },
      {
        accessorKey: "src",
        header: "SOURCE",
      },
      {
        accessorKey: "count",
        header: "# OF RECORDS",
        filterFn: "equals",
        mantineTableHeadCellProps: { align: "right" },
        mantineTableBodyCellProps: { align: "right" },
      },
    ],
    [],
  );

  return (
    <Table
      tableData={tableData}
      columns={columns}
      loading={loading}
      pageName={"BhavSummary"}
      userId={JSON.parse(sessionStorage.getItem("user"))?.userId}
    />
  );
};

export default BhavConfig;
